import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResetPasswordComponent from "../../components/Auth/ResetPasswordComponent";

const ResetPasswordPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/dang-nhap.html');
    }

    return <ResetPasswordComponent redirect={ () => redirect() } />

}

export default ResetPasswordPage;